import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ModalResponseDetails from "components/Common/ModalResponseDetails";
import {
  updateResponse,
  addButtonLabelLanguage,
  deleteButtonLabelLanguage
} from "actions";
import { removeTagFromResponse, addTagToResponse } from "./actions";

class EditResponseModal extends React.Component {
  constructor(props) {
    super(props);

    this.handleUpdateResponse = this.handleUpdateResponse.bind(this);
    this.handleAddTag = this.handleAddTag.bind(this);
    this.handleRemoveTag = this.handleRemoveTag.bind(this);
  }

  handleUpdateResponse(payload) {
    this.props.updateResponse(this.props.response.id, payload);
  }

  handleRemoveTag(tagId) {
    this.props.removeTagFromResponse(this.props.response.id, tagId);
  }

  handleAddTag(tagId) {
    this.props.addTagToResponse(this.props.response.id, tagId);
  }

  render() {
    return (
      <ModalResponseDetails
        {...this.props}
        handleUpdateResponse={this.handleUpdateResponse}
        addButtonLabelLanguage={this.props.addButtonLabelLanguage}
        deleteButtonLabelLanguage={this.props.deleteButtonLabelLanguage}
        handleRemoveTag={this.handleRemoveTag}
        handleAddTag={this.handleAddTag}
      />
    );
  }
}

/**
 * @param {Object} state
 * @param {Object} ownProps
 */
function mapState(state, ownProps) {
  const { responsesLoaded } = state;

  return {
    response: responsesLoaded.get(ownProps.responseId)
  };
}

function mapDispatch(dispatch) {
  return {
    updateResponse: bindActionCreators(updateResponse, dispatch),
    addButtonLabelLanguage: bindActionCreators(addButtonLabelLanguage, dispatch),
    deleteButtonLabelLanguage: bindActionCreators(deleteButtonLabelLanguage, dispatch),
    addTagToResponse: bindActionCreators(addTagToResponse, dispatch),
    removeTagFromResponse: bindActionCreators(removeTagFromResponse, dispatch)
  };
}

const Connector = connect(mapState, mapDispatch)(EditResponseModal);

export default Connector;
